import * as fs from 'fs';
import * as path from 'path';

const defaultPath = '../../node_modules/@allianz/a1-design-tokens/dist/allianz/web/tokens-light-lively-spacious.css';

// loads default token file if no relativePath is provided
// reduces duplication of token file path in e2e tests
export function loadCSS(relativePath: string = defaultPath): string {
  const cssPath = path.resolve(__dirname, relativePath);
  return fs.readFileSync(cssPath, 'utf8');
}
